import { Redirect } from 'expo-router';

export default function Sitemap() {
  return <Redirect href="/" />;
}
